import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_UI_SETTINGS = "ORGANIZATION:GET_UI_SETTINGS";

export interface GetUISettingsAction extends Action {
  type: typeof GET_UI_SETTINGS;
  organization: OrganizationKeyName;
}

export const getUISettings = (
  organization: OrganizationKeyName
): GetUISettingsAction => ({
  type: GET_UI_SETTINGS,
  organization,
});
